import { render, staticRenderFns } from "./VCandidateTasksTemplate.vue?vue&type=template&id=3faf93e1&lang=pug&v-cloak=true"
import script from "./VCandidateTasksTemplate.vue?vue&type=script&lang=ts"
export * from "./VCandidateTasksTemplate.vue?vue&type=script&lang=ts"
import style0 from "./VCandidateTasksTemplate.vue?vue&type=style&index=0&id=3faf93e1&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./CandidateTasksTemplate.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fpages%2FLayout%2Fviews%2FCandidate%2Fviews%2FTasks%2Ftemplate%2FVCandidateTasksTemplate.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports